import firebase from 'firebase/compat/app'
import 'firebase/compat/analytics'

const firebaseConfig = {
  apiKey: 'AIzaSyCVrZM3lqmMAdk7vrk70vc8Df2xpotrheM',
  authDomain: 'warmwishes-live.firebaseapp.com',
  databaseURL: 'https://warmwishes-live-default-rtdb.firebaseio.com',
  projectId: 'warmwishes-live',
  storageBucket: 'warmwishes-live.firebasestorage.app',
  messagingSenderId: '289909986195',
  appId: '1:289909986195:web:fc02bc3242cd7080fe0e66',
  measurementId: 'G-7MPFQNV9BD'
}

export const firebaseApp = !firebase.apps.length ? firebase.initializeApp(firebaseConfig, 'default') : firebase.app('default')

export function enableAnalytics() {
  firebaseApp.analytics().setAnalyticsCollectionEnabled(true)
}

export function disableAnalytics() {
  firebaseApp.analytics().setAnalyticsCollectionEnabled(false)
}
